import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

export const GIRKO_ROUTES: Routes = [
  { path: 'superuser', loadChildren: './+superuser/superuser.module#SuperuserModule' },
  { path: 'edit', loadChildren: './+edit/edit.module#EditModule' },
  { path: 'auction', loadChildren: './+profile-settings/profile-settings.module#ProfileSettingsModule' },
  { path: 'analytics', loadChildren: './+analytics/analytics.module#AnalyticsModule' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(GIRKO_ROUTES),
  ],
  exports: [RouterModule],
})
export class GirkoRouterModule {}
